/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Disabled_Websites_Already_Permanently_DisabledInputs */

const en_disabled_websites_already_permanently_disabled = /** @type {(inputs: Disabled_Websites_Already_Permanently_DisabledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Already Permanently Disabled`)
};

const es_disabled_websites_already_permanently_disabled = /** @type {(inputs: Disabled_Websites_Already_Permanently_DisabledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ya deshabilitado permanentemente`)
};

/**
* | output |
* | --- |
* | "Already Permanently Disabled" |
*
* @param {Disabled_Websites_Already_Permanently_DisabledInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const disabled_websites_already_permanently_disabled = /** @type {((inputs?: Disabled_Websites_Already_Permanently_DisabledInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Disabled_Websites_Already_Permanently_DisabledInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_disabled_websites_already_permanently_disabled(inputs)
	return en_disabled_websites_already_permanently_disabled(inputs)
});